module.exports = __webpack_public_path__ + "static/media/CC.e1c11df5.webp";